// utils/history.js
const historyStack = [];

export const pushToHistory = (pathname) => {
  if (historyStack[historyStack.length - 1] !== pathname) {
    historyStack.push(pathname);
  }
};

export const getLastPage = () => {
  return historyStack.length > 1 ? historyStack[historyStack.length - 2] : null;
};
